import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ElipsisCell from '../../../components/TableBox/Cells/EllipsisCell';
import { TableContext } from '../../../contexts/TableContext';
import Badge from '../../../components/Badge';

interface StockProductRowProps {
  item: any;
}

const StockProductRow: React.FC<StockProductRowProps> = ({ item }) => {
  const { t } = useTranslation();
  const { headCells, rowProps } = useContext(TableContext);

  return (
    <tr>
      {headCells.map((headCell) => {
        if (headCell.id === 'company_product') {
          const product = item.company_product;
          const isViewOnly = !!rowProps?.viewOnly;
          return (
            <td key={headCell.id} style={{ width: headCell.width }}>
              {product ? (
                <Badge
                  badgeTag
                  variant="success"
                  text={product.name}
                  style={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: isViewOnly ? 'default' : 'pointer' }}
                  onClick={
                    isViewOnly
                      ? undefined
                      : () => rowProps?.onMapProduct && rowProps.onMapProduct(item.stockist_product_id, item.stockist_product || '', String(product.division_id ?? ''), String(product.id))
                  }
                />
              ) : (
                <Badge
                  badgeTag
                  variant="secondary"
                  text={t('monthlyStock.addEdit.pageTexts.verifyData.table.mapCompanyProduct')}
                  onClick={
                    isViewOnly
                      ? undefined
                      : () => rowProps?.onMapProduct && rowProps.onMapProduct(item.stockist_product_id, item.stockist_product || '', '', '')
                  }
                />
              )}
            </td>
          );
        }

        if (headCell.id === 'status') {
          return (
            <td key={headCell.id} style={{ width: headCell.width, textAlign: 'center' }}>
              {item.status === 'Linked' ? (
                <i className="ri-circle-fill text-success" />
              ) : (
                <i className="ri-error-warning-line text-warning" />
              )}
            </td>
          );
        }

        const value = item[headCell.id];
        return (
          <ElipsisCell
            key={headCell.id}
            width={headCell.width}
            text={value !== null && value !== undefined ? String(value) : '-'}
          />
        );
      })}
    </tr>
  );
};

export default StockProductRow;
